import { AfterViewInit, Component, ElementRef, input, OnInit, viewChild } from '@angular/core';
import QRCodeStyling from 'qr-code-styling';
import { Options } from 'qr-code-styling/lib/types';

@Component({
  selector: 'kody-qr-customize-preview',
  templateUrl: './qr-customize-preview.component.html',
  styleUrls: ['./qr-customize-preview.component.scss'],
  standalone: false,
})
export class QrCustomizePreviewComponent implements OnInit, AfterViewInit {
  canvas = viewChild.required<ElementRef>('QRCanvas');
  url = input.required<string>();
  locationNumber = input<string>();
  fontName = input<string>();
  themeColor = input<string>();
  hasBackPage = input<boolean>(false);
  isDetailsPage = input<boolean>(false);
  storeLogo = input<string>();

  readonly defaultFontName = 'DM+Sans:wght@400;700';
  readonly defaultThemeColor = '#1566d1';

  detailPoints = ['Scan the QR code', 'Choose your order & pay', 'Your order will be delivered to your table'];
  font: string = 'DM Sans';
  qrColor = '#212121';
  qrCodeOptions: Options = {
    width: 700,
    height: 700,
    type: 'svg',
    image: '/assets/images/kody-qr-insert.svg',
    margin: 16,
    imageOptions: {
      hideBackgroundDots: true,
      imageSize: 0.5,
      margin: 8,
    },
    dotsOptions: { type: 'extra-rounded', color: this.qrColor },
    cornersSquareOptions: { type: 'dot', color: this.qrColor },
    cornersDotOptions: { type: 'dot', color: this.qrColor },
    qrOptions: {
      errorCorrectionLevel: 'M',
    },
  };
  qrCode: QRCodeStyling;

  ngOnInit(): void {
    const fontFamily = this.fontName() || this.defaultFontName;
    this.font = fontFamily.split(':')[0].trim().replace('+', ' ');
  }

  ngAfterViewInit(): void {
    const qrCodeUrl = this.url();
    if (!QRCodeStyling || !qrCodeUrl) {
      return;
    }
    this.qrCodeOptions = {
      ...this.qrCodeOptions,
      data: qrCodeUrl,
    };

    this.qrCode = new QRCodeStyling(this.qrCodeOptions);
    this.qrCode.append(this.canvas().nativeElement);
  }
}
